import { Component, OnInit, OnDestroy } from '@angular/core';
import { TableView } from '../../../helpers/tableview';
import { DevicesService, DeviceStatus, DeviceType } from "./devices.service";
import { DevicePreview } from './devicepreview';
import { DeviceEdit } from './edit';
import { AdForm } from '../../upload/adform';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastyService, ToastOptions } from 'ng2-toasty';
@Component({
  selector: 'app-admin-devices',
  templateUrl: './devices.component.html',
  styleUrls: ['./devices.component.scss'],
  providers: [DevicesService]
})
export class AdminDevicesPage implements OnInit, OnDestroy {

  public table: TableView;
  public DeviceStatus = DeviceStatus;
  public DeviceType = DeviceType;
  public item: AdForm = new AdForm;

  constructor(private devicesService: DevicesService, private toastyService:ToastyService, private modalService: NgbModal){
  }

  ngOnInit() {
      this.table = new TableView(filter => this.devicesService.getDevices(filter));
      this.table.filter.status = DeviceStatus.online;
      this.table.filter.sortBy = "id";
      this.table.filter.sortAsc = false;
      this.table.applyFilter();
      this.table.refreshEvery(30);
  }

  ngOnDestroy() {
    this.table.refreshEvery(0);
  }

  sendPush(deviceID: number) {
    this.devicesService.sendPush(deviceID).then(result => {
      let toastOptions:ToastOptions = {
          title: null,
          msg: "Push sent to device "+deviceID+"!",
          showClose: true,
          timeout: 5000,
          theme: "bootstrap"
      };
      this.toastyService.success(toastOptions);
    }, err => {
      let toastOptions:ToastOptions = {
          title: null,
          msg: err,
          showClose: true,
          timeout: 5000,
          theme: "bootstrap"
      };
      this.toastyService.error(toastOptions);
    });
  }

  // function to show preview of Ad that this Device is playing
  showDeviceAd(adID: number) {
    this.devicesService.getAdByID(adID).then(result => {
      if (result) {
        let modalRef = this.modalService.open(DevicePreview, {size: "lg", windowClass: "-preview"});
        modalRef.componentInstance.ad = result;
      }
    });
  }

  edit(device: any) {
    let modalRef = this.modalService.open(DeviceEdit, {size: "lg", windowClass: "-preview"});
    modalRef.componentInstance.device = JSON.parse(JSON.stringify(device));

    this.devicesService.getMasterList().then(result => {
      modalRef.componentInstance.masterDevices = result;
    });

    modalRef.componentInstance.onSave = (item) => {
      if (item.stat_master_weight_coefficient < 0 || item.stat_master_weight_coefficient > 1) {
        return
      }

      if (item.type == 1){
        item.name = ''
      }
      item.price = Number(item.price)
      item.lat = Number(item.lat)
      item.lng = Number(item.lng)
      item.type = Number(item.type)
      item.city_id = Number(item.city_id)
      item.stat_analyse_interval = Number(item.stat_analyse_interval)
      item.master_device_id = Number(item.master_device_id)
      item.stat_master_device_id = Number(item.stat_master_device_id)
      item.stat_master_weight_coefficient = Number(item.stat_master_weight_coefficient)

      if (!confirm("Press OK to confirm changes!")) {
        return
      };

      this.devicesService.updateDevice(item).then(()=>{
        modalRef.close();
        this.table.applyFilter();
      });
    };

    modalRef.componentInstance.onCancel = () => {
      modalRef.close();
    };
  }
}



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/admin/devices/devices.component.ts